// It exports, as default, the reducer function.
// It exports, as named export, the selectors and the operations as needed.
// Optionally, it exports the types if they are needed in other ducks (other redux folders).

import reducer from "./reducers";
import authOperations from "./operations";

export { authOperations };
export default reducer;
